import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Popconfirm, Space } from 'antd';
import { Table, Button } from 'ui/styled';
import { DeleteOutlined } from '@ant-design/icons';
import { useContainerDimensions, getSecureTableHeight } from 'utils/hooks/useContainerDimensions';
import useOrganizationGroupTable from './hooks/useOrganizationGroupTable';
var OFFSET = 140;
var columns = function (onOrgDelete) { return [
    {
        title: 'Name',
        key: 'name',
        dataIndex: 'name',
        render: function (_, item) { var _a; return "".concat((_a = item === null || item === void 0 ? void 0 : item.third_party_admin) === null || _a === void 0 ? void 0 : _a.abbr, " - ").concat(item === null || item === void 0 ? void 0 : item.name); },
        width: '50%'
    },
    {
        title: 'Actions',
        key: 'actions',
        render: function (_, item) { return (_jsx(Space.Compact, { children: _jsx(Popconfirm, { title: "Are you sure you want to delete this organization?", onConfirm: function () { return onOrgDelete(item === null || item === void 0 ? void 0 : item.id); }, children: _jsx(Button, { icon: _jsx(DeleteOutlined, {}) }) }) })); },
        width: '50%'
    }
]; };
export var OrganizationGroupTable = function (_a) {
    var id = _a.id, filterValues = _a.filterValues, onOrgDelete = _a.onOrgDelete, containerRef = _a.containerRef;
    var data = useOrganizationGroupTable({ filterValues: filterValues, id: id, containerRef: containerRef }).data;
    var loading = data.loading, organizations = data.organizations, scrollLoading = data.scrollLoading;
    var dimensions = useContainerDimensions(containerRef).dimensions;
    return (_jsx(Table, { mixCellTestId: true, filterValues: filterValues, columns: columns(onOrgDelete), loading: loading || scrollLoading, scroll: {
            y: getSecureTableHeight(dimensions.height - OFFSET),
            x: 'max-content'
        }, tableLayout: "fixed", dataSource: organizations }));
};
